export const BACKUP_TYPE = {
  CLOUD: 'cloud',
  LOCAL: 'primary',
  SECONDARY: 'secondary', // backups from a SD card have the 'secondary' type in the BE.
};
